<template>
    <AddFicheStock />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddFicheStock from "@/components/GesCom/FicheStock/AddFicheStock.vue";
  
    export default defineComponent({
      name: "AddFicheStockPage",
      components: {
        
        AddFicheStock,
      },
    });
  </script>